// 消息类型对应的图标
const messageIcons = {
  success:
    '<svg t="1750409756426" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14704" width="32" height="32"><path d="M874.119618 149.859922A510.816461 510.816461 0 0 0 511.997 0.00208a509.910462 509.910462 0 0 0-362.119618 149.857842c-199.817789 199.679789-199.817789 524.581447 0 724.260236a509.969462 509.969462 0 0 0 362.119618 149.857842A508.872463 508.872463 0 0 0 874.119618 874.120158c199.836789-199.679789 199.836789-524.581447 0-724.260236zM814.94268 378.210681L470.999043 744.132295a15.359984 15.359984 0 0 1-5.887994 4.095996c-1.751998 1.180999-2.913997 2.362998-5.276994 2.913997a34.499964 34.499964 0 0 1-13.469986 2.914997 45.547952 45.547952 0 0 1-12.897986-2.303998l-4.095996-2.363997a45.291952 45.291952 0 0 1-7.009992-4.095996l-196.902793-193.789796a34.126964 34.126964 0 0 1-10.555989-25.186973c0-9.37399 3.583996-18.74698 9.98399-25.186974a36.429962 36.429962 0 0 1 50.372947 0l169.98382 167.423824L763.389735 330.220732a37.059961 37.059961 0 0 1 50.371947-1.732998 33.647965 33.647965 0 0 1 11.165988 25.186973 35.544963 35.544963 0 0 1-9.98399 24.575974v-0.04z m0 0" fill="#52C41A" p-id="14705"></path></svg>',
  error:
    '<svg t="1750409855853" class="icon" viewBox="0 0 1028 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16707" width="32" height="32"><path d="M875.086452 153.730058C676.053818-45.302575 353.260522-45.302575 154.128323 153.730058s-199.032634 521.825929 0 720.958129 521.825929 199.032634 720.958129 0 199.032634-521.825929 0-720.958129zM725.836868 725.438604c-9.757478 9.757478-25.488922 9.757478-35.246399 0L514.557604 549.405739 338.624306 725.438604c-9.757478 9.757478-25.488922 9.757478-35.2464 0s-9.757478-25.488922 0-35.2464l176.032865-176.032864-176.032865-175.933299c-9.757478-9.757478-9.757478-25.488922 0-35.246399 9.757478-9.757478 25.488922-9.757478 35.2464 0l176.032864 176.032865 176.032865-176.032865c9.757478-9.757478 25.488922-9.757478 35.246399 0 9.757478 9.757478 9.757478 25.488922 0 35.246399L549.804004 514.15934 725.836868 690.192204c9.657912 9.757478 9.657912 25.488922 0 35.2464z" fill="#F56C6C" p-id="16708"></path></svg>',
  warning:
    '<svg t="1750409840272" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15712" width="32" height="32"><path d="M1001.661867 796.544c48.896 84.906667 7.68 157.013333-87.552 157.013333H110.781867c-97.834667 0-139.050667-69.504-90.112-157.013333l401.664-666.88c48.896-87.552 128.725333-87.552 177.664 0l401.664 666.88zM479.165867 296.533333v341.333334a32 32 0 1 0 64 0v-341.333334a32 32 0 1 0-64 0z m0 469.333334v42.666666a32 32 0 1 0 64 0v-42.666666a32 32 0 1 0-64 0z" fill="#FAAD14" p-id="15713"></path></svg>',
  info: '<svg t="1750409889054" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18607" width="32" height="32"><path d="M512 0C230.4 0 0 227.2 0 512c0 281.6 230.4 512 512 512 284.8 0 512-227.2 512-512S796.8 0 512 0z m0 819.2c-28.8 0-51.2-22.4-51.2-51.2s22.4-51.2 51.2-51.2c28.8 0 51.2 22.4 51.2 51.2 3.2 28.8-22.4 51.2-51.2 51.2z m54.4-220.8c0 28.8-22.4 51.2-51.2 51.2-28.8 0-51.2-22.4-51.2-51.2V256c0-28.8 22.4-51.2 51.2-51.2 28.8 0 51.2 22.4 51.2 51.2v342.4z" fill="#074174" p-id="18608"></path></svg>',
};

// 创建消息容器
function createMessageContainer() {
  // 检查是否已存在
  if (document.getElementById("messageContainer")) {
    return document.getElementById("messageContainer");
  }
  const container = document.createElement("div");
  container.id = "messageContainer";
  container.className = "message-container";
  document.body.appendChild(container);
  return container;
}

/**
 * 显示消息提示框
 * @param {string} type - 消息类型 (success, error, warning, info)
 * @param {string} content - 消息内容
 * @param {object} [option={}] - 配置选项({
 *  duration: 3000,
 *  showClose: true,
 *  top: '30px'
 * })
 */
function showMessage(type, content, option = {}) {
  const { duration = 3000, showClose = true, top = '50%' } = option;
  // 创建消息元素
  const messageBox = document.createElement("div");
  messageBox.className = `message-box ${type}`;

  // 添加图标
  const iconSpan = document.createElement("span");
  iconSpan.className = "message-icon";
  iconSpan.innerHTML = messageIcons[type] || messageIcons.info;
  messageBox.appendChild(iconSpan);

  // 添加内容
  const contentSpan = document.createElement("span");
  contentSpan.className = "message-content";
  contentSpan.textContent = content;
  messageBox.appendChild(contentSpan);

  // 添加关闭按钮
  if (showClose) {
    const closeSpan = document.createElement("span");
    closeSpan.className = "message-close";
    closeSpan.textContent = "×";
    closeSpan.onclick = function () {
      hideMessage(messageBox);
    };
    messageBox.appendChild(closeSpan);
    messageBox.appendChild(closeSpan);
  }

  // 添加到容器
  const container = createMessageContainer();
  container.style.top = top;
  container.appendChild(messageBox);

  // 强制重绘，确保动画生效
  void messageBox.offsetWidth;

  // 显示消息
  messageBox.classList.add("show");

  // 设置自动关闭
  if (duration > 0) {
      setTimeout(() => {
          hideMessage(messageBox);
      }, duration);
  }
}

/**
 * 隐藏并移除消息框
 * @param {HTMLElement} messageBox - 消息元素
 */
function hideMessage(messageBox) {
  messageBox.classList.remove("show");

  // 动画结束后移除元素
  setTimeout(() => {
    messageBox.remove();
  }, 300);
}
